<button type="button" class="ask-launcher" (click)="toggle()" [attr.aria-expanded]="desk.open()">
  {{ desk.open() ? lang.t('close') : lang.t('homeAsk') }}
</button>

@if (desk.open()) {
  <section class="ask-panel" role="dialog" aria-modal="false" aria-labelledby="ask-title">
    <header class="ask-top">
      <div>
        <p class="kicker light" id="ask-title">{{ lang.t('askTitle') }}</p>
        <p class="ask-sub">{{ lang.t('askSub') }}</p>
      </div>
      <button type="button" class="ask-x" (click)="close()">{{ lang.t('close') }}</button>
    </header>
    <div class="ask-log" #log role="log">
      @for (bubble of messages(); track $index; let last = $last) {
        <article class="bubble" [class.you]="bubble.role === 'you'" [class.desk]="bubble.role === 'desk'">
          <p>{{ bubble.text }}</p>
          @if (bubble.actionPath && bubble.actionLabel) {
            <a class="btn tiny deposit" [routerLink]="bubble.actionPath" (click)="close()">{{ bubble.actionLabel }}</a>
          }
          @if (last && bubble.role === 'desk' && !pending()) {
            <div class="bubble-next">
              @for (suggestion of suggestions(); track suggestion) {
                <button type="button" (click)="send(suggestion)">{{ suggestion }}</button>
              }
            </div>
          }
        </article>
      }
      @if (pending()) {
        <article class="bubble desk ask-typing" aria-hidden="true">
          <span></span><span></span><span></span>
        </article>
      }
    </div>
    <p class="sr" aria-live="polite">{{ pending() ? lang.t('askReplying') : '' }}</p>
    <form class="ask-form" (submit)="onSubmit($event, ask)">
      <label class="sr" for="ask">{{ lang.t('homeAsk') }}</label>
      <input id="ask" #ask type="text" maxlength="500" [attr.placeholder]="lang.t('askPh')" autocomplete="off" />
      <button class="btn tiny deposit" type="submit" [disabled]="pending()">{{ lang.t('askSend') }}</button>
    </form>
  </section>
}
